import {Module} from 'vuex'
import {State} from '@/store/store'
import actions from '@/store/modules/views/permission/actions'
import mutations from '@/store/modules/views/permission/mutations'
import getters from '@/store/modules/views/permission/getters'
import PermissionmentState from '@/store/modules/views/permission/states'

const  permission: Module<PermissionmentState, State> = {
  state: new PermissionmentState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default permission
